<template>
  <div
    class="xs12"
  >
    <AppFormHeader
      title="Selecione o filtro desejado"
      icon="check_circle"
    />
    <v-list
      nav
      dense
    >
      <v-list-item-group
        v-model="select"
        color="primary"
      >
        <v-list-item
          v-for="(item, i) in list"
          :key="i"
          :disabled="!item.route || item.disabled"
        >
          <v-list-item-avatar>
            <v-avatar>
              <v-icon>{{ (select === i) ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
            </v-avatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="`${item.title}`" />
          </v-list-item-content>
          <v-list-item-action v-if="item.period">
            <v-icon
              color="grey lighten-2"
              v-html="(item.forceIcon || 'event_available')"
            />
          </v-list-item-action>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>
<script>
import { eventBus } from '@/main'
import AppFormHeader from '@/components/AppFormHeader'
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    eventName: {
      type: String,
      default: '',
      required: true
    }
  },
  components: {
    AppFormHeader
  },
  data () {
    return {
      select: null
    }
  },
  watch: {
    select: function (index) {
      eventBus.$emit(this.eventName, this.list[index])
    }
  }
}
</script>
